import * as React from 'react';
import {Button} from "@mui/material";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import {COUNTRIES} from "../../constants";

export default function ExportOrdersHistory(props) {
    const findCountryInAddress = (address) => {
        if (address.indexOf(",") !== -1) {
            let addressWithOutPostCode = address.replace(address.substring(0, address.indexOf(",") + 1), "").trim();
            if (addressWithOutPostCode.indexOf(",")!== -1) {
                return addressWithOutPostCode.substring(0, addressWithOutPostCode.indexOf(",")).trim();
            }
        }
        return "";
    }
    const handleDownloadData = () => {

        const groupedData = {};
        props.data.forEach((item) => {
            const productId = item.productId;
            if (!groupedData[productId]) {
                groupedData[productId] = [];
            }
            groupedData[productId].push(item);
        });
        console.log("groupedData")
        console.log(groupedData)
        const sortedData = []
        for (let productId in groupedData) {
            let groupedProducts = groupedData[productId]
            let clonedProductForWholeCategory = {}
            for (let clonedProp in clonedProductForWholeCategory) {
                clonedProductForWholeCategory[clonedProp] = null
            }

            clonedProductForWholeCategory["Name"] = null
            clonedProductForWholeCategory["Address"] = null
            clonedProductForWholeCategory["Country"] = null
            clonedProductForWholeCategory["Size if applicable"] = null
            clonedProductForWholeCategory["Asana task link"] = null
            clonedProductForWholeCategory["Recipient"] = null
            clonedProductForWholeCategory["Delivery office/address"] = null
            clonedProductForWholeCategory["Note"] = null
            clonedProductForWholeCategory["Status"] = null
            clonedProductForWholeCategory["Price"] = null
            clonedProductForWholeCategory["Quantity"] = null
            clonedProductForWholeCategory["Charity"] = null


            sortedData.push(clonedProductForWholeCategory)
            let productVariation = groupedProducts[0]["variation"];
            let setName = true;
            let amount = 0;
            groupedProducts.sort((function(product1, product2) {
                if (product1.variation === null || product2.variation === null) {
                    return 1;
                }
                return product1.variation.localeCompare(product2.variation)
            }));
            for (let product in groupedProducts) {
                // let clonedProduct = {...groupedProducts[product]}
                let clonedProduct = {}

                if (setName) {
                    setName = false;
                    if (productVariation) {
                        sortedData.push({
                            "Name": "Category: " + groupedProducts[product]["productTitle"] + " size " + productVariation
                        })
                    } else {
                        sortedData.push({
                            "Name": "Category: " + groupedProducts[product]["productTitle"]
                        })
                    }
                }

                clonedProduct["Name"] = groupedProducts[product]["productTitle"]
                clonedProduct["Address"] = groupedProducts[product]["deliveryAddress"]
                clonedProduct["Country"] = COUNTRIES.includes(groupedProducts[product]["deliveryAddress"].trim()) ?
                    groupedProducts[product]["deliveryAddress"]: findCountryInAddress(groupedProducts[product]["deliveryAddress"])

                clonedProduct["Size if applicable"] = groupedProducts[product]["variation"] ? groupedProducts[product]["variation"] : "Not applicable"
                clonedProduct["Asana task link"] = groupedProducts[product]["asanaLink"]
                clonedProduct["Recipient"] = groupedProducts[product]["receiverFullName"] ? groupedProducts[product]["receiverFullName"] :
                    groupedProducts[product]["fullName"]
                // clonedProduct["Delivery office/address"] = null
                clonedProduct["Note"] = groupedProducts[product]["comment"]
                clonedProduct["Status"] = groupedProducts[product]["status"]
                clonedProduct["Price"] = groupedProducts[product]["price"]
                clonedProduct["Quantity"] = 1
                clonedProduct["Charity"] = groupedProducts[product]["isCharity"] ? "Yes" : "No"



                if (groupedProducts[product]["variation"]) {
                    if (productVariation === groupedProducts[product]["variation"]) {
                        productVariation = groupedProducts[product]["variation"];
                        amount++;
                        sortedData.push(clonedProduct)
                    } else {

                        sortedData.push({
                            "Name": "Total for size " + productVariation,
                            "Quantity": amount
                        })
                        sortedData.push(clonedProduct)
                        productVariation = groupedProducts[product]["variation"];
                        amount = 1;
                    }
                } else  {
                   sortedData.push(clonedProduct)
                }
            }

            if (productVariation) {
                setName = true;
                sortedData.push({
                    "Name": "Total for size " + productVariation,
                    "Quantity": amount
                })
                amount = 1;
            }
            let totalQuantity = {
                ...clonedProductForWholeCategory,
                "Name": "Total quantity",
                "Quantity": groupedProducts.length
            }
            sortedData.push(totalQuantity)
        }

        const ws = XLSX.utils.json_to_sheet(sortedData);


        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
        XLSX.writeFile(wb, props.filename + ".xlsx");
    }
    return (
        <Button variant="contained"
                color="warning"
                onClick={handleDownloadData}
        >
            Export to file
        </Button>
    );
}
ExportOrdersHistory.propTypes = {
    filename: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
};